// File: typecopy-front-end/src/components/StartAdButton.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

const StartAdButton = ({ adId }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/ad-page/${adId}`);
    };

    return (
        <Button variant="contained" color="primary" onClick={handleClick}>
            Start Ad Typing Session
        </Button>
    );
};

export default StartAdButton;